/* global axios */
import ApiClient from './ApiClient';

class Monitors extends ApiClient {
  constructor() {
    super('monitors', { accountScoped: true });
  }

  updateState(data) {
    return axios.post(`${this.url}/change_state`, data);
  }

  updateUserState(data) {
    return axios.post(`${this.url}/change_user_state`, data);
  }

  getUserData(data) {
    return axios.post(`${this.url}/user_data`, data);
  }

  getUserConv(data) {
    return axios.post(`${this.url}/user_conv`, data);
  }

  getTableData(searchkey) {
    return axios.post(`${this.url}/table_data`, { searchkey });
  }

  getAgentData(searchkey) {
    return axios.post(`${this.url}/agent_data`, { searchkey });
  }

  getTimeData(searchkey) {
    return axios.post(`${this.url}/time_data`, { searchkey });
  }
}

export default new Monitors();
